import React from "react";
import EnsaConstant from "./EnsaConstant";

const ChartP3 = ({ dataLiterasi, className }) => {
    require("./Ensa.css");
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <div className={className}>
                {dataLiterasi.map((item, i) =>
                    <div key={i}>
                        <div className="label-skor" style={{ fontWeight: '700', fontSize:'24px', color: '#015E56' }}>{item.skor}</div>
                        <div className="chart-label" style={{ backgroundColor: item.color }}>{item.value}</div>
                        <div className="desc-p3">{item.key}</div>
                    </div>
                )}
            </div>
        </div>

    );
};

export default ChartP3;
